(function () {
  if (window.BadeloftFinishMedia) return;

  window.BadeloftFinishMedia = true;

  var pendingVariantId = null;
  var pendingMediaId = null;
  var pendingStartedAt = 0;
  var activeRun = 0;
  var galleryObserver = null;
  var galleryObserverTarget = null;
  var documentObserver = null;
  var lockClassTimer = null;
  var preloadedUrls = {};

  function getMediaMap() {
    var node = document.querySelector('[data-bf-finish-media-map]');
    if (!node) return {};

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function getFinishInput(target) {
    if (!target || typeof target.closest !== 'function') return null;

    var row = target.closest('.bf-cfg__row--finish');
    if (!row) return null;

    if (target.matches && target.matches('input[data-variant-id]')) {
      return target;
    }

    var label = target.closest('.variant-option__button-label');
    return label ? label.querySelector('input[data-variant-id]') : null;
  }

  function getCheckedFinishInput() {
    return document.querySelector('.bf-cfg__row--finish input[data-variant-id]:checked');
  }

  function getFinishKey(input) {
    var value = input && input.value ? input.value.toLowerCase() : '';
    return value.indexOf('glossy') > -1 ? 'glossy' : 'matte';
  }

  function getMappedMediaId(variantId) {
    if (!variantId) return null;

    var map = getMediaMap();
    return map[String(variantId)] || null;
  }

  function findRenderMediaIdForFinish(finishKey) {
    var gallery = findGallery();
    if (!gallery || !finishKey) return null;

    var mediaNodes = Array.prototype.slice.call(gallery.querySelectorAll('.product-media[data-media-id]'));
    var finishNeedle = '| ' + finishKey + ' |';

    var matched = mediaNodes.find(function (node) {
      var image = node.querySelector('img');
      var alt = image ? (image.getAttribute('alt') || '').toLowerCase() : '';

      return alt.indexOf('badeloft render 2026') > -1 && alt.indexOf(finishNeedle) > -1;
    });

    return matched ? matched.getAttribute('data-media-id') : null;
  }

  function resolveMediaId(variantId, input) {
    var mediaId = getMappedMediaId(variantId);
    if (findMediaSlide(findGallery(), mediaId)) return mediaId;

    var finishKey = getFinishKey(input || getCheckedFinishInput());
    var renderMediaId = findRenderMediaIdForFinish(finishKey);

    return renderMediaId || mediaId;
  }

  function syncColourTiles(input) {
    var finishKey = getFinishKey(input || getCheckedFinishInput());
    var tiles = document.querySelectorAll('[data-bf-colour-tile]');

    Array.prototype.forEach.call(tiles, function (tile) {
      var image = tile.getAttribute('data-' + finishKey + '-image');
      var href = tile.getAttribute('data-' + finishKey + '-href');

      if (image) {
        tile.style.backgroundImage = 'url("' + image.replace(/"/g, '\\"') + '")';
      }
      if (href) {
        tile.setAttribute('href', href);
      }
    });
  }

  function findGallery(root) {
    var scope = root || document;
    return scope.querySelector('main media-gallery') || scope.querySelector('media-gallery');
  }

  function findMediaSlide(gallery, mediaId) {
    if (!gallery || !mediaId) return null;

    var mediaNodes = Array.prototype.slice.call(gallery.querySelectorAll('.product-media[data-media-id]'));
    var mediaNode = mediaNodes.find(function (node) {
      return String(node.getAttribute('data-media-id')) === String(mediaId);
    });

    return mediaNode ? mediaNode.closest('slideshow-slide') : null;
  }

  function getActiveSlide(gallery) {
    if (!gallery) return null;

    return Array.prototype.slice.call(gallery.querySelectorAll('slideshow-slide')).find(function (slide) {
      return slide.getAttribute('aria-hidden') === 'false';
    });
  }

  function getActiveMediaId(gallery) {
    var active = getActiveSlide(gallery);
    var activeMedia = active ? active.querySelector('.product-media[data-media-id]') : null;

    return activeMedia ? activeMedia.getAttribute('data-media-id') : null;
  }

  function getMediaImageUrl(mediaId) {
    var gallery = findGallery();
    var slide = findMediaSlide(gallery, mediaId);
    var image = slide ? slide.querySelector('img') : null;

    return image ? image.currentSrc || image.src : '';
  }

  function preloadMedia(mediaId) {
    var url = getMediaImageUrl(mediaId);
    if (!url || preloadedUrls[url]) return;

    var image = new Image();
    image.decoding = 'async';
    image.src = url;
    preloadedUrls[url] = image;
  }

  function preloadMappedMedia() {
    var map = getMediaMap();
    Object.keys(map).forEach(function (variantId) {
      preloadMedia(map[variantId]);
    });
  }

  function ensureLockStyle() {
    if (document.getElementById('bf-finish-media-lock-style')) return;

    var style = document.createElement('style');
    style.id = 'bf-finish-media-lock-style';
    style.textContent = [
      'html.bf-finish-media-lock media-gallery,',
      'html.bf-finish-media-lock media-gallery *,',
      'html.bf-finish-media-lock .product-media-container {',
      '  scroll-behavior: auto !important;',
      '  transition-duration: 0s !important;',
      '  animation-duration: 0s !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function setLockClass() {
    ensureLockStyle();
    document.documentElement.classList.add('bf-finish-media-lock');

    if (lockClassTimer) {
      window.clearTimeout(lockClassTimer);
    }

    lockClassTimer = window.setTimeout(function () {
      document.documentElement.classList.remove('bf-finish-media-lock');
      lockClassTimer = null;
    }, 900);
  }

  function selectMedia(mediaId) {
    if (!mediaId) return false;

    var gallery = findGallery();
    if (!gallery) return false;

    if (String(getActiveMediaId(gallery)) === String(mediaId)) return true;

    var slide = findMediaSlide(gallery, mediaId);
    var slides = gallery.slideshow && gallery.slideshow.refs ? gallery.slideshow.refs.slides : null;
    slides = slides && slides.length
      ? Array.prototype.slice.call(slides)
      : Array.prototype.slice.call(gallery.querySelectorAll('slideshow-slide'));

    var index = slide ? slides.indexOf(slide) : -1;
    if (index < 0) return false;

    if (gallery.slideshow && typeof gallery.slideshow.select === 'function') {
      gallery.slideshow.select(index, undefined, { animate: false });
      return String(getActiveMediaId(gallery)) === String(mediaId);
    }

    var thumbnail = gallery.querySelector('.slideshow-controls__thumbnail[data-slide-index="' + index + '"]');
    if (thumbnail) {
      thumbnail.click();
      return String(getActiveMediaId(gallery)) === String(mediaId);
    }

    return false;
  }

  function observeGallery() {
    var gallery = findGallery();
    if (!gallery || gallery === galleryObserverTarget) return;

    if (galleryObserver) {
      galleryObserver.disconnect();
    }

    galleryObserverTarget = gallery;
    galleryObserver = new MutationObserver(function () {
      enforcePendingMedia();
    });
    galleryObserver.observe(gallery, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'aria-selected', 'class'],
      childList: true,
      subtree: true
    });
  }

  function observeDocument() {
    if (documentObserver || !document.body) return;

    documentObserver = new MutationObserver(function () {
      observeGallery();
      preloadMappedMedia();
      enforcePendingMedia();
    });
    documentObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function enforcePendingMedia() {
    if (!pendingMediaId || Date.now() - pendingStartedAt > 5400) return false;

    preloadMedia(pendingMediaId);
    return selectMedia(pendingMediaId);
  }

  function scheduleVariantMedia(variantId, input) {
    if (!variantId) return;

    variantId = String(variantId);
    var mediaId = resolveMediaId(variantId, input);
    if (!mediaId) return;

    pendingVariantId = variantId;
    pendingMediaId = mediaId;
    pendingStartedAt = Date.now();
    activeRun += 1;
    setLockClass();
    observeGallery();
    observeDocument();

    var run = activeRun;
    var tries = 0;
    var startedAt = pendingStartedAt;
    var frameUntil = startedAt + 700;

    preloadMedia(mediaId);
    selectMedia(mediaId);

    function frameTick() {
      if (run !== activeRun || pendingVariantId !== variantId) return;

      enforcePendingMedia();

      if (Date.now() < frameUntil) {
        window.requestAnimationFrame(frameTick);
      }
    }

    function tick() {
      if (run !== activeRun || pendingVariantId !== variantId) return;
      tries += 1;

      enforcePendingMedia();

      var elapsed = Date.now() - startedAt;
      if (elapsed < 5200 && tries < 70) {
        window.setTimeout(tick, elapsed < 900 ? 40 : 100);
        return;
      }

      if (pendingVariantId === variantId) {
        pendingVariantId = null;
        pendingMediaId = null;
      }
    }

    window.requestAnimationFrame(frameTick);
    tick();
  }

  function handleFinishIntent(target) {
    var input = getFinishInput(target);
    if (!input || !input.dataset.variantId) return;

    syncColourTiles(input);
    scheduleVariantMedia(input.dataset.variantId, input);
  }

  var initialFinishInput = getCheckedFinishInput();
  syncColourTiles(initialFinishInput);
  preloadMappedMedia();
  observeGallery();
  observeDocument();

  // Let the server-rendered curated gallery order own the initial media. Finish-media
  // enforcement is only for an actual finish interaction; scheduling it here held one
  // media item for 5.4s and repeatedly overrode early arrow or thumbnail navigation.

  document.addEventListener('pointerdown', function (event) {
    handleFinishIntent(event.target);
  }, true);

  document.addEventListener('touchstart', function (event) {
    handleFinishIntent(event.target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    handleFinishIntent(event.target);
  }, true);

  document.addEventListener('click', function (event) {
    handleFinishIntent(event.target);
  }, true);

  document.addEventListener('change', function (event) {
    handleFinishIntent(event.target);
  }, true);

  document.addEventListener('variant:update', function (event) {
    var variantId = event.detail && event.detail.resource ? event.detail.resource.id : null;
    var checked = getCheckedFinishInput();

    if (!variantId && pendingVariantId && Date.now() - pendingStartedAt < 8000) {
      variantId = pendingVariantId;
    }

    if (!variantId && checked && checked.dataset.variantId && Date.now() - pendingStartedAt < 8000) {
      variantId = checked.dataset.variantId;
    }

    if (getMappedMediaId(variantId)) {
      scheduleVariantMedia(variantId, checked);
    }

    if (checked) {
      syncColourTiles(checked);
    }
  }, true);
})();
